export const interaction = {
  thumb: {
    hoverStyle: {
      opacity: 0.8,
      scale: 1.03,
    },
    focusStyle: {
      opacity: 0.75,
      scale: 1.02,
    },
    pressStyle: {
      opacity: 0.7,
      scale: 1.01,
    },
  },
  scale: {
    hoverStyle: {
      scale: 1.08,
    },
    focusStyle: {
      scale: 1.06,
    },
    pressStyle: {
      scale: 1.04,
    },
  },
  opacity: {
    hoverStyle: {
      opacity: 0.8,
    },
    focusStyle: {
      opacity: 0.75,
    },
    pressStyle: {
      opacity: 0.6,
    },
  },
}
